import { css } from 'styled-components'

const textSerif = css`
  font-family: 'Taviraj', serif;
`

export { textSerif }
